import { combineReducers } from 'redux';

import { data_sources, notification_destinations, web_notifications } from 'Shared/reducers/data_sources';
import { errorMessage } from 'Shared/reducers/messages';

import { app, admin, default_options, goals, organization, syncStatus, view } from 'Shared/reducers';

import smart_links from 'Shared/reducers/smart_links';
import { clientSideSearchData } from 'Shared/reducers/clientSideSearchData';
import { timeseries, chart_preferences, chart_metrics } from 'Shared/reducers/timeseries';
import { charts } from 'Shared/reducers/charts';
import workspaces from 'Shared/reducers/workspaces';
import workspace from 'Shared/reducers/workspace';
import { recommendations } from 'Shared/reducers/recommendations';
import { recommendation_previews } from 'Shared/reducers/recommendation_previews';
import button_states from 'Shared/reducers/button_states';
import managerAssistantSettings from 'Shared/reducers/managerAssistantSettings';
import workspaceNotificationCards from 'Shared/reducers/workspaceNotificationCards';
import { salesforce_record_modal } from 'Shared/reducers/salesforce_record_modal';
import recommendationAnalytics from 'Shared/reducers/recommendation_analytics';
import user from 'Shared/reducers/user';
import onboardingState from 'Shared/reducers/onboardingState';
import optionsForInviteToWorkspaceModal from 'Shared/reducers/optionsForInviteToWorkspaceModal';
import optionsForInviteToTeammateModal from 'Shared/reducers/optionsForInviteToTeammateModal';
import members from 'Shared/reducers/members';
import search from 'Shared/reducers/search';
import homePage from 'Shared/reducers/homePage';
import selectedUuids from 'Shared/reducers/selectedUuids';
import sortedActionItemsUuids from 'Shared/reducers/sortedActionItemsUuids';
import sortedDiscussionTopicsUuids from 'Shared/reducers/sortedDiscussionTopicsUuids';
import workspacePrivateNote from 'Shared/reducers/workspacePrivateNote';
import meetingItems from 'Shared/reducers/meetingItems';
import zoomContext from 'Shared/reducers/zoomContext';
import { GoalsReducer as goalsItems } from 'Shared/reducers/Goals.reducer';
import feedbacks from 'Shared/reducers/Feedbacks.reducer';
import feedbackComments from 'Shared/reducers/FeedbackComments.reducer';
import { UsersReducer as usersItems } from 'Shared/reducers/Users.reducer';
import { BaInfoReducer as BaInfo } from 'Shared/reducers/BaInfo.reducer';
import { EmployeeReducer as PiEmployeeItems } from 'Shared/reducers/Employees.reducer';
import { PartnerInfoReducer as PartnerInfo } from 'Shared/reducers/PartnerInfo.reducer';
import { WorkspaceTemplatesReducer as workspaceTemplatesItems } from 'Shared/reducers/WorkspaceTemplates.reducer';
import { CommentsReducer as commentsItems } from 'Shared/reducers/Comments.reducer';
import loaders from 'Shared/reducers/Loaders.reducer';
import { MeetingItemsReducer as meetingItemsV2 } from 'Shared/reducers/MeetingItems.reducer';
import { WorkspaceItemCommentsReducer as workspaceItemComments } from 'Shared/reducers/WorkspaceItemComments.reducer';
import { WorkspaceMeetingModeReducer as workspaceMeetingMode } from 'Shared/reducers/WorkspaceMeetingMode.reducer';
import { MeetingTranscriptionsReducer as meetingTranscriptions } from 'Shared/reducers/MeetingTranscriptions.reducer';
import { WorkspaceRecentUpdatesReducer as workspaceRecentUpdates } from 'Shared/reducers/WorkspaceRecentUpdates.reducer';
import { ReviewsReducer as reviewItems } from 'Shared/reducers/Reviews.reducer';
import { ReactionsReducer as reactionItems } from 'Shared/reducers/Reactions.reducer';
import { UserSuggestionsReducer as userSuggestionItems } from './shared/reducers/userSuggestions.reducer';
import { CalendarMeetingssReducer as calendarMeetings } from './shared/reducers/CalendarMeetings.reducer';
import { WorkspaceAiSettingsReducer as workspaceAiSettings } from './shared/reducers/WorkspaceAiSettings.reducer';
import { UpdateAiSettingsReducer as updateAiSettings } from './shared/reducers/UpdateAiSettings.reducer';
import { ReviewTemplatesReducer as reviewTemplates } from './shared/reducers/ReviewTemplates.reducer';
import { ReviewCyclesReducer as reviewCycles } from './shared/reducers/ReviewCycles.reducer';
import { TeamInfo as teamInfo } from './shared/reducers/TeamInfo.reducer';

const rootReducer = combineReducers({
  admin,
  app,
  button_states,
  charts,
  chart_preferences,
  chart_metrics,
  data_sources,
  default_options,
  smart_links,
  errorMessage,

  goals,
  feedbacks,
  feedbackComments,
  organization,
  clientSideSearchData,
  workspaces,
  workspace,
  managerAssistantSettings,
  workspaceNotificationCards,
  notification_destinations,
  recommendations,
  recommendation_previews,
  salesforce_record_modal,
  recommendationAnalytics,
  syncStatus,

  timeseries,
  user,
  view,
  web_notifications,
  optionsForInviteToWorkspaceModal,
  optionsForInviteToTeammateModal,

  members,

  search,
  homePage,
  selectedUuids,
  sortedActionItemsUuids,
  sortedDiscussionTopicsUuids,
  workspacePrivateNote,
  meetingItems,
  goalsItems,
  usersItems,
  BaInfo,
  PartnerInfo,
  commentsItems,
  workspaceTemplatesItems,
  loaders,
  meetingItemsV2,
  workspaceItemComments,
  workspaceMeetingMode,
  meetingTranscriptions,
  workspaceRecentUpdates,
  reviewItems,
  reactionItems,
  userSuggestionItems,
  calendarMeetings,
  workspaceAiSettings,
  updateAiSettings,
  reviewTemplates,
  reviewCycles,
  PiEmployeeItems,
  teamInfo,

  // TODO: Old or doesn't fit new state tree schema. Deprecate or remove.
  onboardingState,
  zoomContext,
});

export default rootReducer;
